<template>
  <v-container fluid v-if="story != null">
    <v-layout row wrap>
      <v-flex pa-2>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>{{story.title}}</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Description</v-list-tile-title>
                <v-list-tile-sub-title v-html="story.description"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Owner</v-list-tile-title>
                <v-list-tile-sub-title v-if="story.owner">
                  {{story.owner.name}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Sprint</v-list-tile-title>
                <v-list-tile-sub-title v-if="story.sprint">
                  {{story.sprint.name}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Status</v-list-tile-title>
                <v-list-tile-sub-title v-html="story.status"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="warning" muted @click="archive(story)" v-if="!story.archived">
              Archive
            </v-btn>
             <v-btn color="warning" muted @click="dearchive(story)" v-if="story.archived">
              De-archive
            </v-btn>
            <v-btn color="error" @click="remove(story)">
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      bottom
      fab
      fixed
      right
      @click="goToEdit"
    >
      <v-icon>create</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'StoryShowView',
  computed: {
    story() {
      return this.$store.getters.getStory(this.$route.params.id);
    },
  },
  methods: {
    goToEdit() {
      this.$router.push({
        name: 'Edit Story',
        params: { id: this.$route.params.id },
      });
    },
    remove(story) {
      this.$store.commit('deleteStory', story);
      this.$router.push({ name: 'Stories' });
    },
    archive(story) {
      story.archived = true;
      this.$store.commit('updateStory', story);
      this.$router.push({ name: 'Stories' });
    },
    dearchive(story) {
      story.archived = false;
      this.$store.commit('updateStory', story);
      this.$router.push({ name: 'Stories' });
    },
  },
};
</script>
